import { v4 } from "uuid";

const uniqueId = (prefix: string = "id-") => `${prefix}-${v4()}`;

export default uniqueId;
